
// @ts-nocheck
import locale__home_node_locales_ar_yml from "../locales/ar.yml";
import locale__home_node_locales_en_yml from "../locales/en.yml";


export const localeCodes =  [
  "ar",
  "en"
]

export const localeLoaders = {
  "ar": [{ key: "../locales/ar.yml", load: () => Promise.resolve(locale__home_node_locales_ar_yml), cache: true }],
  "en": [{ key: "../locales/en.yml", load: () => Promise.resolve(locale__home_node_locales_en_yml), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "ar",
      "iso": "ar",
      "name": "عربي",
      "dir": "rtl",
      "files": [
        "locales/ar.yml"
      ]
    },
    {
      "code": "en",
      "iso": "en",
      "name": "EN",
      "dir": "ltr",
      "files": [
        "locales/en.yml"
      ]
    }
  ],
  "defaultLocale": "ar",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "locales/",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ar",
    "iso": "ar",
    "name": "عربي",
    "dir": "rtl",
    "files": [
      {
        "path": "locales/ar.yml"
      }
    ]
  },
  {
    "code": "en",
    "iso": "en",
    "name": "EN",
    "dir": "ltr",
    "files": [
      {
        "path": "locales/en.yml"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
